import React, { FC } from 'react'

import { NextSeo } from 'next-seo'

import AppLayout from '~/components/layouts/AppLayout'
import CongratulationView from '~/views/CongratulationView'

import Paths from '~/utils/paths'

const CongratulationPage: FC = () => {
  return (
    <AppLayout bgcolor="bg.primary.main">
      <NextSeo
        title="Congratulation"
        description="Congratulation"
        canonical={Paths.congratulation.index}
        openGraph={{
          title: 'Congratulation',
          description: 'Congratulation'
        }}
      />

      <CongratulationView />
    </AppLayout>
  )
}

export default CongratulationPage
